const FormPopUpWrapper =({children})=>{
  return <div className="registration-popup-wrap">{children}</div>;
}

export default FormPopUpWrapper